'use es6';

import { Map as ImmutableMap } from 'immutable';
import resolve from './resolve';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { WaterfallVisualization } from 'reporting-visualizations/visualizations/waterfall/waterfallRecords';
import { TableVisualization } from 'reporting-visualizations/visualizations/table/tableRecords';
import { DEFAULT_X_FIELD, DEFAULT_Y_FIELD } from './constants';
import { callWidgetDrilldown } from '../lib/salesAnalytics/drilldowns';
import { getDrilldownColumns } from '../lib/salesAnalytics/drilldownColumns';
import { isSearch, isTable } from '../lib/salesAnalytics/helpers';
import SalesAnalyticsReport from '../lib/salesAnalytics/SalesAnalyticsReport';
import { jsx as _jsx } from "react/jsx-runtime";
const chartViz = (report, data, {
  onDrilldown
}) => {
  const primaryDataset = data.getIn(['primary', 'data'], Dataset());
  return WaterfallVisualization({
    data: {
      primary: primaryDataset
    },
    layer: {
      dataset: 'primary',
      x: {
        field: DEFAULT_X_FIELD
      },
      y: {
        field: DEFAULT_Y_FIELD
      },
      onClick: ({
        point: {
          name
        }
      }) => {
        const row = primaryDataset.get('data').find(point => point.get(DEFAULT_X_FIELD) === name);
        callWidgetDrilldown(report, onDrilldown)({
          dataset: primaryDataset,
          point: ImmutableMap({
            row
          })
        });
      }
    }
  });
};
const tableViz = (report, data, {
  onDrilldown
}) => {
  const primaryDataset = data.getIn(['primary', 'data'], Dataset());
  const columns = [DEFAULT_X_FIELD, DEFAULT_Y_FIELD, 'netPipelineImpact', 'count'].map(field => {
    return {
      dataset: 'primary',
      field,
      onClick: field !== DEFAULT_X_FIELD ? callWidgetDrilldown(report, onDrilldown) : null
    };
  });
  return TableVisualization({
    data: {
      primary: primaryDataset
    },
    columns
  });
};
const drilldownViz = (report, data) => TableVisualization({
  data: {
    primary: data.getIn(['primary', 'data'], Dataset())
  },
  columns: getDrilldownColumns(report)
});
const getVisualization = (report, data, props) => isSearch(report) ? drilldownViz(report, data, props) : isTable(report) ? tableViz(report, data, props) : chartViz(report, data, props);
const Index = props => /*#__PURE__*/_jsx(SalesAnalyticsReport, Object.assign({}, props, {
  resolveReport: resolve,
  getVisualization: getVisualization
}));
export default Index;